// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__Ktj8u","header":"Messages_header__3Y4Bk"};